import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Sanitizes HTML to prevent XSS attacks
 * @param {string} html - HTML string to sanitize
 * @returns {string} - Sanitized text
 */
const sanitizeHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  
  // Create a temporary div element
  const div = document.createElement('div');
  div.textContent = html; // textContent automatically escapes HTML
  return div.innerHTML;
};

const WarningAlert = ({ icon=null, type="warning", message }) => {
  // Sanitize message to prevent XSS attacks (security requirement)
  // Never use dangerouslySetInnerHTML without sanitization
  return (
    <Alert variant={type} className="d-flex align-items-start">
      {icon}
      <div className="w-100" dangerouslySetInnerHTML={{ __html: message }}></div>
    </Alert>
  );
};

export default WarningAlert;
